/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE")

package features.orderStatus.internal

import features.orderStatus.models.OrderStatusResponseModel
import kangaroorewards.appsdk.core.io.IOResult
import kangaroorewards.appsdk.core.network.NetworkRequest
import kangaroorewards.appsdk.core.network.base.PathParameter
import kangaroorewards.appsdk.core.network.base.replaceInPath

internal class OrderStatusRequest : NetworkRequest() {

    suspend fun getOrderStatus(
        overrideHeaders: Map<String, String>? = null,
        businessId: String
    ): IOResult<OrderStatusResponseModel> {
        return safeNetworkCall {
            get(
                endpoint = OrderStatusEndpoint.replaceInPath(
                    PathParameter("businessId", businessId),
                ),
                serverHostId = 0,
                overrideHeaders = overrideHeaders
            )
        }
    }
}
